import { Polyglot } from 'components/translate';
import DateHelper, { shortFormatDate } from 'helpers/Date';
import { UiService } from 'modules/ui';

import Request from '@hotmart/request';

class UserDetailService {
  isQuizProfile = (item) =>
    Boolean(item.quizProfile && Object.keys(item.quizProfile).length);

  formatData = (content = []) =>
    content.map((item) => ({
      ...item,
      completedDate: item.completedDate ? this.formatDate(item) : '',
      moduleExtra: this.formatContentType(item)
    }));

  formatDate = (item) =>
    item && DateHelper.format(item.completedDate, shortFormatDate);

  formatContentType(item = {}) {
    return item && item.moduleExtra
      ? Polyglot.t('users_manager.users_detail.extra_content')
      : Polyglot.t('users_manager.users_detail.main_content');
  }

  getHistoricType = ([value = '', { TITLE: title = '' }]) => ({
    value,
    label: Polyglot.t(title)
  });

  async toggleWhitelistUserStatus(endpoint, params) {
    try {
      await Request(`whitelist.${endpoint}`, params);
    } catch (e) {
      UiService.setAlertError('error');
    }
  }

  fetchPiracyActivities(userAreaId) {
    return Request('piracy.getActivities', { userAreaId });
  }

  fetchPiracyActivitiesDetail(piracyEventId) {
    return Request('piracy.getActivityDetail', { piracyEventId });
  }
}

export default new UserDetailService();
